import { OrdersDto } from '../../types';

export const IOrderApiId = Symbol.for('IOrderApi');

export interface IOrderApi {
    /**
     * Get order history.
     * @param take
     * @param skip
     * @param language
     */
    getOrders(take: number, skip: number, language: string): Promise<OrdersDto | undefined>;
}
